import { render, staticRenderFns } from "./EditBaseMailTemplate.vue?vue&type=template&id=ae9811c2&"
import script from "./EditBaseMailTemplate.vue?vue&type=script&lang=ts&"
export * from "./EditBaseMailTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
